/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

//TODO i18n
require('./bootstrap');
require('./legacy/custom-panel');
require('./redesign/inputs');


import Vue from 'vue';
import VModal from 'vue-js-modal';
import vuetify from './plugins/vuetify'; // path to vuetify export
import VueClosable from '@ryanburnette/vue-closable';

Vue.use(VueClosable);
Vue.use(VModal, {
    dynamic: true,
    dynamicDefaults: {
        clickToClose: true
    }
});

Vue.prototype.window = window;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
// test

import CostCarrierMonthChart from './Components/Statistic/CostCarrierMonthChart.vue';
import OverTimeWeekChart from './Components/Statistic/OverTimeWeekChart.vue';
import OverTimeMonthChart from './Components/Statistic/OverTimeMonthChart.vue';
import OverTimeYearChart from './Components/Statistic/OverTimeYearChart.vue';
import WorkTimeWeekDayChart from './Components/Statistic/WorkTimeWeekDayChart.vue';
import WorkTimeMonthDayChart from './Components/Statistic/WorkTimeMonthDayChart.vue';
import WorkTimeYearMonthCompareChart from './Components/Statistic/WorkTimeYearMonthCompareChart.vue';
import WorkTimeTable from './Components/Statistic/WorkTimeTable.vue';
import CostCarrierSelect from "./Components/CostCarrierSelect";
import DepartmentSelect from "./Components/DepartmentSelect";
import AuthorizationSelect from "./Components/AuthorizationSelect";
import MultipleCostCarrierSelect from "./Components/MultipleCostCarrierSelect";
import TravelExpenseReportWizard from "./Components/TravelExpenseReport/Wizard";
import Editor from "./Components/Editor";
import MediaLibrary from "./Components/MediaLibrary";
import Organigram from "./Components/Organigram";
import WeekDaySelectMultiple from "./Components/WeekDaySelectMultiple";
import AddButton from "./Components/Redesign/AddButton";
import CheckBox from "./Components/Redesign/CheckBox";
import SearchBox from "./Components/Redesign/SearchBox";
import MemberProfile from "./Components/Redesign/MemberProfile";
import PlayButton from "./Components/Redesign/PlayButton";
import MemberLogin from "./Components/Redesign/MemberLogin";
import PauseButton from "./Components/Redesign/PauseButton";
import ButtonNormal from "./Components/Redesign/ButtonNormal";
import ThumbsUp from "./Components/Redesign/ThumbsUp";
import ThumbsDown from "./Components/Redesign/ThumbsDown";
import ExportButton from "./Components/Redesign/ExportButton";
import StatusYellow from "./Components/Redesign/ExportButton";
import DemoDate from "./Components/Redesign/DemoDate";

// User Profile Components
import ProfilePicture from './Components/User/ProfilePicture';

// Redesign Components
import BorderedInput from './Components/Redesign/BorderedInput';
import FoldOutCard from './Components/Redesign/FoldOutCard';
import CustomCostCarrier from './Components/Redesign/CustomCostCarrier';
import DailyWorktimeSelect from './Components/Redesign/DailyWorktimeSelect';
import ApplicationMailAssignToDepartment from './Components/Redesign/ApplicationMails/AssignToDepartment';
import ApplicationMailActionsMenu from './Components/Redesign/ApplicationMails/ActionsMenu';
import ApplicationMailActionsMenuInbox from './Components/Redesign/ApplicationMails/ActionsMenuInbox';
import ApplicationMailActionsMenuInvite from './Components/Redesign/ApplicationMails/ActionsMenuInvite';
import ApplicationMailActionsMenuHr from './Components/Redesign/ApplicationMails/ActionsMenuHR';
import InvoiceActionsMenu from './Components/Redesign/Invoices/ActionsMenu';
import TopbarLogoutMenu from './Components/Redesign/Topbar/LogoutMenu';

import TravelExpenseReportOverview from './Components/TravelExpenseReport/Overview';
import UserTaxDataForm from './Components/User/TaxDataForm';
import HeavenUserDataImport from './Components/HeavenUserDataImport';
import EmployeeTile from './Components/Redesign/EmployeeTile';
import ContractSalariesInput from './Components/Redesign/ContractSalariesInput';
import ContractVacationDaysInput from './Components/Redesign/ContractVacationDaysInput';
import UsersSelect from './Components/UsersSelect';

import AppfcHome from './Components/AppfcHome.vue';
import router from './Components/Forecast/Router/router';
import ForecastHelper from './Components/Forecast/ForecastHelper';
window.ForecastHelper = ForecastHelper;

import VueGoogleCharts from 'vue-google-charts'

Vue.use(VueGoogleCharts)
window.EventBus = new Vue();

// App
window.app = new Vue({
    el: '#main-container',
    vuetify:vuetify,
    router,

    components: {
        CostCarrierMonthChart,
        OverTimeWeekChart,
        OverTimeMonthChart,
        OverTimeYearChart,
        WorkTimeWeekDayChart,
        WorkTimeMonthDayChart,
        WorkTimeYearMonthCompareChart,
        WorkTimeTable,
        CostCarrierSelect,
        ProfilePicture,
        Editor,
        MediaLibrary,
        AuthorizationSelect,
        MultipleCostCarrierSelect,
        Organigram,
        WeekDaySelectMultiple,

        BorderedInput,

        AddButton,
        CheckBox,
        SearchBox,
        MemberProfile,
        PlayButton,
        MemberLogin,
        PauseButton,
        ButtonNormal,
        ThumbsUp,
        ThumbsDown,
        ExportButton,
        StatusYellow,
        DemoDate,
        FoldOutCard,
        CustomCostCarrier,
        DailyWorktimeSelect,
        TravelExpenseReportWizard,

        TravelExpenseReportOverview,
        UserTaxDataForm,
        HeavenUserDataImport,
        EmployeeTile,
        ApplicationMailAssignToDepartment,
        ApplicationMailActionsMenu,
        ApplicationMailActionsMenuInbox,
        ApplicationMailActionsMenuInvite,
        ApplicationMailActionsMenuHr,
        InvoiceActionsMenu,
        TopbarLogoutMenu,
        
        DepartmentSelect,
        ContractSalariesInput,
        ContractVacationDaysInput,
        AppfcHome,
        UsersSelect,
    },
});